import { useCallback } from 'react';

import {
	type ACTEvent,
	AD_CONTROL_DROP_DOWN_MENU_CLOSED,
	isInteractedUIEvent,
} from '@atlassian/ad-control-toolkit';

import { useCustomAnalyticEvents } from '../analytics-hooks';
import type { CohortType, RecommendationEntityIdType } from '../constants';

type UseOnACTEventsProps = {
	cohort: CohortType | string;
	sessionId: string;
};

type onACTEventsType = ({
	event,
	entityId,
}: {
	event: ACTEvent;
	entityId: RecommendationEntityIdType;
}) => void;

interface UseOnACTEventsResponse {
	onACTEvents: onACTEventsType;
}

export function useOnACTEvents({ cohort, sessionId }: UseOnACTEventsProps): UseOnACTEventsResponse {
	const { fireUIAnalyticsEvent } = useCustomAnalyticEvents({
		cohort,
		sessionId,
	});

	const onACTEvents = useCallback(
		({ event, entityId }: { event: ACTEvent; entityId: RecommendationEntityIdType }) => {
			const { type, analyticsEvent } = event;

			if (type === AD_CONTROL_DROP_DOWN_MENU_CLOSED) {
				return;
			}

			if (!analyticsEvent) {
				return;
			}

			if (isInteractedUIEvent(analyticsEvent)) {
				fireUIAnalyticsEvent({ analyticsEvent, entityId });
			}
		},
		[fireUIAnalyticsEvent],
	);

	return {
		onACTEvents,
	};
}
